import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserProfile } from 'src/app/model/userProfile.model';

@Component({
  selector: 'app-integration',
  templateUrl: './integration.component.html',
  styleUrls: ['./integration.component.css',
    '../../../../node_modules/primeflex/primeflex.css']
})
export class IntegrationComponent implements OnInit, OnChanges {

  @Input() user: UserProfile;
  @Output() emitSave: EventEmitter<any> = new EventEmitter();

  tzones: any[];
  revaiForm: FormGroup;
  ingestionForm: FormGroup;

  constructor(
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.buildForm();
  }

  ngOnChanges() {
    this.buildForm();
  }

  buildForm() {
    this.revaiForm = this.fb.group({
      revai_access_token: [this.user && this.user.revai_access_token || ''],
      youtube_link: [this.user && this.user.youtube_link || ''],
    });
    this.revaiForm.disable();
    this.ingestionForm = this.fb.group({
      ingestion_url: [this.user && this.user.ingestion_url || ''],
    });
    this.ingestionForm.disable();
  }

  saveAccessToken(event) {
    this.dirtyAllFields();

    if (this.revaiForm.valid) {
      this.revaiForm.disable();
      if (!this.revaiForm.dirty) {
        return;
      }
      this.emitSave.emit(this.revaiForm.value);
    }
  }

  editAccessToken(event) {
    this.revaiForm.enable();
  }

  cancelAccessToken($event) {
    this.revaiForm.disable();
  }

  generateNewUrl($event) {
    console.log('creat new url');
  }


  dirtyAllFields() {
    const controls = this.revaiForm.controls;
    Object.keys(controls).forEach(field => {
      controls[field].markAsDirty();
    });
  }
}